import PROGRESS_STATES from "../requestProgressState";
import getRequestInfo from "./getRequestInfo";
export default function isInProgress(state, scope) {
    const requestInfo = getRequestInfo(state, scope);
    return Boolean(requestInfo &&
        (requestInfo.progressState === PROGRESS_STATES.INITIAL ||
            requestInfo.progressState === PROGRESS_STATES.INPROGRESS));
}
